"use strict";
"use client";

var _excluded = ["type"],
  _excluded2 = ["value", "defaultValue", "onValueChange", "collapsible"],
  _excluded3 = ["value", "defaultValue", "onValueChange"],
  _excluded4 = ["__scopeAccordion", "disabled", "dir", "orientation"],
  _excluded5 = ["__scopeAccordion", "value"],
  _excluded6 = ["__scopeAccordion"],
  _excluded7 = ["__scopeAccordion"],
  _excluded8 = ["__scopeAccordion"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && _typeof(from) === "object" || typeof from === "function") {
    var _iterator = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step;
    try {
      var _loop = function _loop() {
        var key = _step.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// packages/react/accordion/src/index.ts
var src_exports = {};
__export(src_exports, {
  Accordion: function Accordion() {
    return _Accordion;
  },
  AccordionContent: function AccordionContent() {
    return _AccordionContent;
  },
  AccordionHeader: function AccordionHeader() {
    return _AccordionHeader;
  },
  AccordionItem: function AccordionItem() {
    return _AccordionItem;
  },
  AccordionTrigger: function AccordionTrigger() {
    return _AccordionTrigger;
  },
  Content: function Content() {
    return Content2;
  },
  Header: function Header() {
    return _Header;
  },
  Item: function Item() {
    return _Item;
  },
  Root: function Root() {
    return Root2;
  },
  Trigger: function Trigger() {
    return Trigger2;
  },
  createAccordionScope: function createAccordionScope() {
    return _createAccordionScope;
  }
});
module.exports = __toCommonJS(src_exports);

// packages/react/accordion/src/Accordion.tsx
var import_react = __toESM(require("react"));
var import_react_context = require("@radix-ui/react-context");
var import_react_collection = require("@radix-ui/react-collection");
var import_react_compose_refs = require("@radix-ui/react-compose-refs");
var import_primitive = require("@radix-ui/primitive");
var import_react_use_controllable_state = require("@radix-ui/react-use-controllable-state");
var import_react_primitive = require("@radix-ui/react-primitive");
var CollapsiblePrimitive = __toESM(require("@radix-ui/react-collapsible"));
var import_react_collapsible = require("@radix-ui/react-collapsible");
var import_react_id = require("@radix-ui/react-id");
var import_react_direction = require("@radix-ui/react-direction");
var import_jsx_runtime = require("react/jsx-runtime");
var ACCORDION_NAME = "Accordion";
var ACCORDION_KEYS = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"];
var _ref = (0, import_react_collection.createCollection)(ACCORDION_NAME),
  _ref2 = _slicedToArray(_ref, 3),
  Collection = _ref2[0],
  useCollection = _ref2[1],
  createCollectionScope = _ref2[2];
var _ref3 = (0, import_react_context.createContextScope)(ACCORDION_NAME, [createCollectionScope, import_react_collapsible.createCollapsibleScope]),
  _ref4 = _slicedToArray(_ref3, 2),
  createAccordionContext = _ref4[0],
  _createAccordionScope = _ref4[1];
var useCollapsibleScope = (0, import_react_collapsible.createCollapsibleScope)();
var _Accordion = import_react.default.forwardRef(function (props, forwardedRef) {
  var type = props.type,
    accordionProps = _objectWithoutProperties(props, _excluded);
  var singleProps = accordionProps;
  var multipleProps = accordionProps;
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(Collection.Provider, {
    scope: props.__scopeAccordion,
    children: type === "multiple" ? /* @__PURE__ */(0, import_jsx_runtime.jsx)(AccordionImplMultiple, _objectSpread(_objectSpread({}, multipleProps), {}, {
      ref: forwardedRef
    })) : /* @__PURE__ */(0, import_jsx_runtime.jsx)(AccordionImplSingle, _objectSpread(_objectSpread({}, singleProps), {}, {
      ref: forwardedRef
    }))
  });
});
_Accordion.displayName = ACCORDION_NAME;
var _createAccordionConte = createAccordionContext(ACCORDION_NAME),
  _createAccordionConte2 = _slicedToArray(_createAccordionConte, 2),
  AccordionValueProvider = _createAccordionConte2[0],
  useAccordionValueContext = _createAccordionConte2[1];
var _createAccordionConte3 = createAccordionContext(ACCORDION_NAME, {
    collapsible: false
  }),
  _createAccordionConte4 = _slicedToArray(_createAccordionConte3, 2),
  AccordionCollapsibleProvider = _createAccordionConte4[0],
  useAccordionCollapsibleContext = _createAccordionConte4[1];
var AccordionImplSingle = import_react.default.forwardRef(function (props, forwardedRef) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    _props$onValueChange = props.onValueChange,
    onValueChange = _props$onValueChange === void 0 ? function () {} : _props$onValueChange,
    _props$collapsible = props.collapsible,
    collapsible = _props$collapsible === void 0 ? false : _props$collapsible,
    accordionSingleProps = _objectWithoutProperties(props, _excluded2);
  var _ref5 = (0, import_react_use_controllable_state.useControllableState)({
      prop: valueProp,
      defaultProp: defaultValue,
      onChange: onValueChange
    }),
    _ref6 = _slicedToArray(_ref5, 2),
    value = _ref6[0],
    setValue = _ref6[1];
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(AccordionValueProvider, {
    scope: props.__scopeAccordion,
    value: value ? [value] : [],
    onItemOpen: setValue,
    onItemClose: import_react.default.useCallback(function () {
      return collapsible && setValue("");
    }, [collapsible, setValue]),
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(AccordionCollapsibleProvider, {
      scope: props.__scopeAccordion,
      collapsible: collapsible,
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(AccordionImpl, _objectSpread(_objectSpread({}, accordionSingleProps), {}, {
        ref: forwardedRef
      }))
    })
  });
});
var AccordionImplMultiple = import_react.default.forwardRef(function (props, forwardedRef) {
  var valueProp = props.value,
    defaultValue = props.defaultValue,
    _props$onValueChange2 = props.onValueChange,
    onValueChange = _props$onValueChange2 === void 0 ? function () {} : _props$onValueChange2,
    accordionMultipleProps = _objectWithoutProperties(props, _excluded3);
  var _ref7 = (0, import_react_use_controllable_state.useControllableState)({
      prop: valueProp,
      defaultProp: defaultValue,
      onChange: onValueChange
    }),
    _ref8 = _slicedToArray(_ref7, 2),
    _ref8$ = _ref8[0],
    value = _ref8$ === void 0 ? [] : _ref8$,
    setValue = _ref8[1];
  var handleItemOpen = import_react.default.useCallback(function (itemValue) {
    return setValue(function () {
      var prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return [].concat(_toConsumableArray(prevValue), [itemValue]);
    });
  }, [setValue]);
  var handleItemClose = import_react.default.useCallback(function (itemValue) {
    return setValue(function () {
      var prevValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return prevValue.filter(function (value2) {
        return value2 !== itemValue;
      });
    });
  }, [setValue]);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(AccordionValueProvider, {
    scope: props.__scopeAccordion,
    value: value,
    onItemOpen: handleItemOpen,
    onItemClose: handleItemClose,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(AccordionCollapsibleProvider, {
      scope: props.__scopeAccordion,
      collapsible: true,
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(AccordionImpl, _objectSpread(_objectSpread({}, accordionMultipleProps), {}, {
        ref: forwardedRef
      }))
    })
  });
});
var _createAccordionConte5 = createAccordionContext(ACCORDION_NAME),
  _createAccordionConte6 = _slicedToArray(_createAccordionConte5, 2),
  AccordionImplProvider = _createAccordionConte6[0],
  useAccordionContext = _createAccordionConte6[1];
var AccordionImpl = import_react.default.forwardRef(function (props, forwardedRef) {
  var __scopeAccordion = props.__scopeAccordion,
    disabled = props.disabled,
    dir = props.dir,
    _props$orientation = props.orientation,
    orientation = _props$orientation === void 0 ? "vertical" : _props$orientation,
    accordionProps = _objectWithoutProperties(props, _excluded4);
  var accordionRef = import_react.default.useRef(null);
  var composedRefs = (0, import_react_compose_refs.useComposedRefs)(accordionRef, forwardedRef);
  var getItems = useCollection(__scopeAccordion);
  var direction = (0, import_react_direction.useDirection)(dir);
  var isDirectionLTR = direction === "ltr";
  var handleKeyDown = (0, import_primitive.composeEventHandlers)(props.onKeyDown, function (event) {
    var _triggerCollection$cl;
    if (!ACCORDION_KEYS.includes(event.key)) return;
    var target = event.target;
    var triggerCollection = getItems().filter(function (item) {
      var _item$ref$current;
      return !((_item$ref$current = item.ref.current) !== null && _item$ref$current !== void 0 && _item$ref$current.disabled);
    });
    var triggerIndex = triggerCollection.findIndex(function (item) {
      return item.ref.current === target;
    });
    var triggerCount = triggerCollection.length;
    if (triggerIndex === -1) return;
    event.preventDefault();
    var nextIndex = triggerIndex;
    var homeIndex = 0;
    var endIndex = triggerCount - 1;
    var moveNext = function moveNext() {
      nextIndex = triggerIndex + 1;
      if (nextIndex > endIndex) {
        nextIndex = homeIndex;
      }
    };
    var movePrev = function movePrev() {
      nextIndex = triggerIndex - 1;
      if (nextIndex < homeIndex) {
        nextIndex = endIndex;
      }
    };
    switch (event.key) {
      case "Home":
        nextIndex = homeIndex;
        break;
      case "End":
        nextIndex = endIndex;
        break;
      case "ArrowRight":
        if (orientation === "horizontal") {
          if (isDirectionLTR) {
            moveNext();
          } else {
            movePrev();
          }
        }
        break;
      case "ArrowDown":
        if (orientation === "vertical") {
          moveNext();
        }
        break;
      case "ArrowLeft":
        if (orientation === "horizontal") {
          if (isDirectionLTR) {
            movePrev();
          } else {
            moveNext();
          }
        }
        break;
      case "ArrowUp":
        if (orientation === "vertical") {
          movePrev();
        }
        break;
    }
    var clampedIndex = nextIndex % triggerCount;
    (_triggerCollection$cl = triggerCollection[clampedIndex].ref.current) === null || _triggerCollection$cl === void 0 || _triggerCollection$cl.focus();
  });
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(AccordionImplProvider, {
    scope: __scopeAccordion,
    disabled: disabled,
    direction: dir,
    orientation: orientation,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(Collection.Slot, {
      scope: __scopeAccordion,
      children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.div, _objectSpread(_objectSpread({}, accordionProps), {}, {
        "data-orientation": orientation,
        ref: composedRefs,
        onKeyDown: disabled ? void 0 : handleKeyDown
      }))
    })
  });
});
var ITEM_NAME = "AccordionItem";
var _createAccordionConte7 = createAccordionContext(ITEM_NAME),
  _createAccordionConte8 = _slicedToArray(_createAccordionConte7, 2),
  AccordionItemProvider = _createAccordionConte8[0],
  useAccordionItemContext = _createAccordionConte8[1];
var _AccordionItem = import_react.default.forwardRef(function (props, forwardedRef) {
  var __scopeAccordion = props.__scopeAccordion,
    value = props.value,
    accordionItemProps = _objectWithoutProperties(props, _excluded5);
  var accordionContext = useAccordionContext(ITEM_NAME, __scopeAccordion);
  var valueContext = useAccordionValueContext(ITEM_NAME, __scopeAccordion);
  var collapsibleScope = useCollapsibleScope(__scopeAccordion);
  var triggerId = (0, import_react_id.useId)();
  var open = value && valueContext.value.includes(value) || false;
  var disabled = accordionContext.disabled || props.disabled;
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(AccordionItemProvider, {
    scope: __scopeAccordion,
    open: open,
    disabled: disabled,
    triggerId: triggerId,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(CollapsiblePrimitive.Root, _objectSpread(_objectSpread(_objectSpread({
      "data-orientation": accordionContext.orientation,
      "data-state": getState(open)
    }, collapsibleScope), accordionItemProps), {}, {
      ref: forwardedRef,
      disabled: disabled,
      open: open,
      onOpenChange: function onOpenChange(open2) {
        if (open2) {
          valueContext.onItemOpen(value);
        } else {
          valueContext.onItemClose(value);
        }
      }
    }))
  });
});
_AccordionItem.displayName = ITEM_NAME;
var HEADER_NAME = "AccordionHeader";
var _AccordionHeader = import_react.default.forwardRef(function (props, forwardedRef) {
  var __scopeAccordion = props.__scopeAccordion,
    headerProps = _objectWithoutProperties(props, _excluded6);
  var accordionContext = useAccordionContext(ACCORDION_NAME, __scopeAccordion);
  var itemContext = useAccordionItemContext(HEADER_NAME, __scopeAccordion);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(import_react_primitive.Primitive.h3, _objectSpread(_objectSpread({
    "data-orientation": accordionContext.orientation,
    "data-state": getState(itemContext.open),
    "data-disabled": itemContext.disabled ? "" : void 0
  }, headerProps), {}, {
    ref: forwardedRef
  }));
});
_AccordionHeader.displayName = HEADER_NAME;
var TRIGGER_NAME = "AccordionTrigger";
var _AccordionTrigger = import_react.default.forwardRef(function (props, forwardedRef) {
  var __scopeAccordion = props.__scopeAccordion,
    triggerProps = _objectWithoutProperties(props, _excluded7);
  var accordionContext = useAccordionContext(ACCORDION_NAME, __scopeAccordion);
  var itemContext = useAccordionItemContext(TRIGGER_NAME, __scopeAccordion);
  var collapsibleContext = useAccordionCollapsibleContext(TRIGGER_NAME, __scopeAccordion);
  var collapsibleScope = useCollapsibleScope(__scopeAccordion);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(Collection.ItemSlot, {
    scope: __scopeAccordion,
    children: /* @__PURE__ */(0, import_jsx_runtime.jsx)(CollapsiblePrimitive.Trigger, _objectSpread(_objectSpread(_objectSpread({
      "aria-disabled": itemContext.open && !collapsibleContext.collapsible || void 0,
      "data-orientation": accordionContext.orientation,
      id: itemContext.triggerId
    }, collapsibleScope), triggerProps), {}, {
      ref: forwardedRef
    }))
  });
});
_AccordionTrigger.displayName = TRIGGER_NAME;
var CONTENT_NAME = "AccordionContent";
var _AccordionContent = import_react.default.forwardRef(function (props, forwardedRef) {
  var __scopeAccordion = props.__scopeAccordion,
    contentProps = _objectWithoutProperties(props, _excluded8);
  var accordionContext = useAccordionContext(ACCORDION_NAME, __scopeAccordion);
  var itemContext = useAccordionItemContext(CONTENT_NAME, __scopeAccordion);
  var collapsibleScope = useCollapsibleScope(__scopeAccordion);
  return /* @__PURE__ */(0, import_jsx_runtime.jsx)(CollapsiblePrimitive.Content, _objectSpread(_objectSpread(_objectSpread({
    role: "region",
    "aria-labelledby": itemContext.triggerId,
    "data-orientation": accordionContext.orientation
  }, collapsibleScope), contentProps), {}, {
    ref: forwardedRef,
    style: _objectSpread(_defineProperty(_defineProperty({}, "--radix-accordion-content-height", "var(--radix-collapsible-content-height)"), "--radix-accordion-content-width", "var(--radix-collapsible-content-width)"), props.style)
  }));
});
_AccordionContent.displayName = CONTENT_NAME;
function getState(open) {
  return open ? "open" : "closed";
}
var Root2 = _Accordion;
var _Item = _AccordionItem;
var _Header = _AccordionHeader;
var Trigger2 = _AccordionTrigger;
var Content2 = _AccordionContent;